var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "bestSelledProductsToggle";
var PLUGIN_VERSION = "v1.0";

var DEFAULTS = {
  container: '.bestSelledProducts table',
  element: 'tr',
  defaultCount: 3,
  effect: 'fadeToggle'
};

/**
 * set basic variables
 * create options and settings for this instance
 * @param element - DOM Element the plugin is applied to
 * @param options - custom settings to be merged with DEFAULTS
 * @constructor
 */
var BestSelledProductsToggle = function (element, options) {
  this.element = element;
  this.state = 0;

  // merge options
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.initialise();
};

/**
 * init function
 */
BestSelledProductsToggle.prototype.initialise = function () {
  this.listenForClick();
};

BestSelledProductsToggle.prototype.listenForClick = function () {
  var self = this;

  $(this.element).on('click', function(e) {
    e.preventDefault();
    var defaultText = $(this).data('textToggleDefault');
    var newText = $(this).data('textToggleToggled');
    if ( self.state == 0 ) {
      $(this).html(newText);
      self.handleOtherProducts();
      self.state = 1;
    } else {
      $(this).html(defaultText);
      self.handleOtherProducts();
      self.state = 0;
    }

  });
};

BestSelledProductsToggle.prototype.handleOtherProducts = function () {
  var affectedElements = $(this.options.container + ' ' + this.options.element + ':gt(' + Number(this.options.defaultCount - 1) + ')');
  if (this.options.effect == 'fadeToggle') {
    $(affectedElements).fadeToggle();
  }
};

/**
 * decide, which methods will be "public"
 */
var API = {
  //method: PluginSkeleton.prototype.method
  //loadMarkers: GoogleMap.prototype.loadMarkers
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  var args = arguments;

  return this.each(function () {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if (!plugin) {
      plugin = new BestSelledProductsToggle(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};

/**
 * setDefaults with $.pluginSkeleton.setDefaults();
 */
$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
$[PLUGIN_NAME].setDefaults = function (newOptions) {
  DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.best-selled-products-toggle.js